// Facade over the warehouse operations endpoints (WarehouseStatusController).
//
// Both calls are Global Admin or Data Warehouse Health only, and the API
// enforces that itself -- the sidebar hiding the page is a convenience, not the
// control. Anyone else gets { success: false } back, which unwrap turns into a
// thrown error.
//
// No mock branch, unlike analyticsApi.js. This page exists to say what the
// warehouse is doing right now; a canned answer would be the one thing it must
// never show.

import api from '../api/api';

function unwrap(response) {
  if (!response.data?.success) {
    throw new Error(response.data?.message || 'Request failed');
  }
  return response.data.data;
}

// Status headline, the night-by-night history, recent runs, table freshness,
// the transform chain and backfill progress -- one round trip.
export const getWarehouseDashboard = async () =>
  unwrap(await api.get('warehouse/dashboard'));

// Loaded when a run row is expanded, not up front: a nightly is ~35 steps.
export const getWarehouseRunSteps = async (runId) =>
  unwrap(await api.get(`warehouse/runs/${runId}/steps`));
